module.exports = __webpack_public_path__ + "assets/lodash.99b8cc8f.svg";